<template>
  <div class="application_form_review">
    <template v-if="isShowBtn">
      <div class="query_wapper">
        <div class="query_items">
          <el-button-group>
            <el-button
              @click="selectType(1)"
              :class="switchType === 1?'select':'normal'"
              style="width:100px"
            >报名表</el-button>
            <el-button @click="selectType(2)" :class="switchType === 2?'select':'normal'">运动员照片</el-button>
          </el-button-group>
        </div>
        <div class="query_items">
          <el-select
            style="width:200px;margin:0 20px;"
            v-model="headValue.year"
            @change="getMatch"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item,index) in yearLists"
              :value="item.value"
              :label="item.label"
              :key="index"
            ></el-option>
          </el-select>
        </div>
        <div class="query_items">
          <span style="font-size:16px;font-family:PF">赛事名称：</span>
          <el-select
            style="width:260px"
            v-model="headValue.matchName"
            :popper-append-to-body="false"
            @change="$event=>getSignDetail($event)"
          >
            <el-option
              v-for="(item,index) in matchList"
              :key="index"
              :value="item.id"
              :label="item.matchName"
            ></el-option>
          </el-select>
        </div>
        <div class="query_items">
          <el-button style="width:90px;margin:0 10px 0 20px;" @click="print" type="warning">打印</el-button>
        </div>
      </div>
      <template v-if="switchType === 1">
        <div class="table_box">
          <div class="box">
            <div class="left">
              <section class="head_title">
                <span>单位名称：</span>
                {{userInfo.schoolName}}
              </section>
              <section class="head_title">
                <p>
                  <span>领</span>
                  <span>队：</span>
                </p>
                {{details.leaderName}}
              </section>
              <section class="head_title">
                <p>
                  <span>教</span>
                  <span>练：</span>
                </p>
                {{getCoachName}}
              </section>
            </div>
            <div class="right">
              <section class="head_title">
                <p>
                  <span>组</span>
                  <span>别：</span>
                </p>
                {{details.groupText}}
              </section>
              <section class="head_title">
                <span>联系电话：</span>
                {{details.leaderPhone}}
              </section>
              <section class="head_title">
                <span>联系电话：</span>
                {{details.coachPhones}}
              </section>
            </div>
          </div>
          <table
            style="border:1px solid #ddd;margin-top:20px;width:100%"
            border="0"
            cellspacing="0"
            cellpadding="0"
          >
            <thead>
              <tr>
                <template v-for="(item,index) in columns.slice(0,6)">
                  <th
                    colspan="1"
                    rowspan="2"
                    :key="index"
                    :style="{width:item.width + 'px'}"
                    class="ths big_title"
                  >
                    <div class="cell">{{item.title}}</div>
                  </th>
                </template>
                <th class="ths big_title" :colspan="competitiveGymnasticsNum" style="border-bottom:1px solid #ddd">
                  <div class="cell">竞技操项目</div>
                </th>
                <th class="ths big_title" :colspan="nationalFitnessNum" style="border-bottom:1px solid #ddd">
                  <div class="cell">全民健身操项目</div>
                </th>
              </tr>

              <tr>
                <th
                  v-for="(item,index) in columns.slice(6)"
                  :key="index"
                  class="ths big_title"
                  :style="{width:item.width + 'px'}"
                >
                  <div class="cell">{{item.title}}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in details.athleteList" :key=" index">
                <td style="text-align:center;color:#444;">
                  <div class="cell">{{index + 1}}</div>
                </td>
                <template v-for="(temp,num) in columns.slice(1)">
                  <td style="text-align:center;color:#444;" :key="num + '_' + index">
                    <div class="cell">{{getKey(temp.key,index)}}</div>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
          <footer v-if="reviewState === 1">
            <el-button
              :loading="loadingData.submitLoading"
              class="btns"
              style="width:90px"
              @click="operation('agree')"
            >同意</el-button>
            <el-button
              @click="operation('reject')"
              :loading="loadingData.saveLoading"
              class="btns"
              style="margin:0 20px;width:90px"
            >驳回</el-button>
          </footer>
          <footer v-else>
            <span style="font-size:22px">审核状态：</span>
            <span
              :style="{color:reviewState === 0?'#1E63B0':reviewState === 2?'#FD6666':'#1CC28C'}"
              style="font-size:18px"
            >{{reviewState === 0?'报名未提交':reviewState === 2?'审核未通过':'审核已通过'}}</span>
          </footer>
        </div>
      </template>
      <athletesPhoto v-else :details="details"></athletesPhoto>
      <div id="prints">
        <div style="page-break-after:always;">
          <h2 class="match_title">{{currentProject.matchName}}</h2>
          <div class="box">
            <div class="left">
              <section class="head_title">
                <span>单位名称：</span>
                {{userInfo.schoolName}}
              </section>
              <section class="head_title">
                <p>
                  <span>领</span>
                  <span>队：</span>
                </p>
                {{details.leaderName}}
              </section>
              <section class="head_title">
                <p>
                  <span>教</span>
                  <span>练：</span>
                </p>
                {{getCoachName}}
              </section>
            </div>
            <div class="right">
              <section class="head_title">
                <p>
                  <span>组</span>
                  <span>别：</span>
                </p>
                {{details.groupText}}
              </section>
              <section class="head_title">
                <span>联系电话：</span>
                {{details.leaderPhone}}
              </section>
              <section class="head_title">
                <span>联系电话：</span>
                {{details.coachPhones}}
              </section>
            </div>
          </div>
          <table
            v-for="t in getTableNum"
            :style="{marginTop:t!== 1?'80px':''}"
            style="border:1px solid #ddd;margin-top:20px;width:100%;page-break-after:always"
            border="0"
            :key="t"
            cellspacing="0"
            cellpadding="0"
          >
            <thead>
              <tr>
                <template v-for="(item,index) in columns.slice(0,6)">
                  <th
                    colspan="1"
                    rowspan="2"
                    :key="index"
                    :style="{width:item.width + 'px',borderRight:index == columns.length - 1?'none!important':'1px solid #999'}"
                    class="ths big_title"
                  >
                    <div class="cell">{{item.title}}</div>
                  </th>
                </template>

                <th
                  class="ths big_title"
                  :colspan="competitiveGymnasticsNum"
                  style="border-bottom:1px solid #999;border-right:1px solid #999;min-width:100px"
                >
                  <div class="cell">竞技操项目</div>
                </th>
                <th
                  class="ths big_title"
                  :colspan="nationalFitnessNum"
                  style="border-bottom:1px solid #999;border-right:0;min-width:100px"
                >
                  <div class="cell">全民健身操项目</div>
                </th>
              </tr>
              <tr>
                <th
                  v-for="(item,index) in columns.slice(6)"
                  :key="index"
                  class="ths big_title"
                  :style="{width:item.width + 'px',borderRight:index === (columns.slice(6).length - 1)?'none':'1px solid #999'}"
                >
                  <div class="cell">{{item.title}}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item,index) in details.athleteList.slice((t -1) * 14,t* 14)"
                :key=" index"
              >
                <td style="text-align:center;color:#444;border-right:1px solid #999">
                  <div class="cell">{{t==1?(index + 1):(((t - 1) * 14) + index + 1)}}</div>
                </td>
                <template v-for="(temp,num) in columns.slice(1)">
                  <td
                    :style="{borderRight:num == columns.length - 2?'none!important':'1px solid #999'}"
                    style="text-align:center;color:#444;"
                    :key="num + '_' + index"
                  >
                    <div class="cell">{{getKey(temp.key,index)}}</div>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
        <athletesPhoto :details="details"></athletesPhoto>
      </div>
    </template>
    <template v-else>
      <div class="query_wapper">
        <el-select
          :popper-append-to-body="false"
          style="margin:0 20px;"
          v-model="headValue.year"
          @change="getMatch"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
        <el-select
          :popper-append-to-body="false"
          v-model="headValue.matchName"
          @change="$event=>getSignDetail($event)"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.matchName"
          ></el-option>
        </el-select>
      </div>
      <div style="padding:160px 0 0 250px">
        <img src="../../assets/img/signUp/no_data.png" alt />
      </div>
    </template>
    <div
      v-if="!hideMask"
      style="width:100%;height:100vh;position:fixed;background:#fff;top:106px;z-index:999999;left:290px;"
    ></div>
  </div>
</template>
<script>
import {
  signDetail,
  getSignListBySchool,
  schoolAudit
} from "@/api/sign-up-match";
import { getSession } from "@/utils/storage";
import { getCoachList } from "@/api/athletes.js";
import { selectiveYear, message } from "@/common/js/mixins";
import athletesPhoto from "./components/athletes-photo";
export default {
  mixins: [selectiveYear, message],
  components: {
    athletesPhoto
  },
  data() {
    return {
      switchType: 1,
      hideMask: false,
      isShowBtn: true,
      reviewState: 1,
      userInfo: JSON.parse(getSession("userInfo")),
      details: {},
      coachList: [],
      currentProject: {},
      athleteList: [],
      matchList: [],
      headValue: {
        year: "",
        matchName: ""
      },
      query: {
        id: "",
        coachIds: [],
        leaderName: ""
      },
      competitiveGymnasticsNum: 0,
      nationalFitnessNum: 0,
      columns: [
        {
          title: "序号",
          width: 60
        },
        {
          title: "姓名",
          width: 60,
          key: "athleteName"
        },
        {
          title: "性别",
          width: 60,
          key: "genderText"
        },
        {
          title: "入学时间",
          width: 100,
          key: "startSchoolDateText"
        },
        {
          title: "学制",
          width: 100,
          key: "schoolSystemText"
        },
        {
          title: "注册号",
          width: 160,
          key: "registerNumber"
        }
      ],
      loadingData: {
        submitLoading: false,
        saveLoading: false
      }
    };
  },
  computed: {
    getCoachName() {
      let coach = this.details.coachIds ? this.details.coachIds.split(",") : [];
      let arr = [];
      this.coachList.filter(item => {
        if (coach.includes(item.id)) {
          arr.push(item.name);
        }
      });
      return arr.join(",");
    },
    getKey() {
      return (key, index) => {
        let keys = "";
        this.columns.filter(item => {
          if (item.key === key) {
            switch (key) {
              case "groupId":
                const group = this.details.athleteList[index][item.key];
                keys =
                  group == 1
                    ? "甲组"
                    : group == 2
                    ? "乙组"
                    : group == 4
                    ? "丙组"
                    : "丁组";
                break;
              default:
                keys = this.details.athleteList[index][item.key];
                break;
            }
          }
        });
        return keys;
      };
    },
    getTableNum() {
      const length = this.details.athleteList
        ? this.details.athleteList.length
        : 0;
      let num = 0;
      if (length > 14) {
        if (parseFloat(length / 14) > parseInt(length / 14)) {
          num = parseInt(length / 14) + 1;
        } else num = parseInt(length / 14);
      } else if (length > 0 && length <= 14) {
        num = 1;
      }
      return num;
    }
  },
  methods: {
    print() {
      this.$nextTick(() => {
        this.isShowBottom = true;
        var el = document.querySelector("#prints"),
          iframe = document.createElement("IFRAME"),
          doc = null;
        iframe.setAttribute("id", "print-iframe");
        iframe.setAttribute(
          "style",
          "width:100%;font-size:20px;text-align:center"
        );
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        doc.write(
          '<html><head><style type="text/css" media="print">ul{list-style:none} @page {size: auto; margin: 0mm 5mm;} .athlete_name {font-size:14px!important}' +
            ".athlete_regist_number{font-size:12px!important } .border_bottom {border-bottom:1px solid #999!important} .border_top {border-top:1px solid #999!important}" +
            ".border_right {border-right:1px solid #999!important} .border_left {border-left:1px solid #999!important} .margin_top {margin-top:20mm!important}" +
            ".match_title {margin:10mm 0 20px;text-align:left;font-size:22px;font-family:PF;font-weight:bold;} .athletes_photo header h2 {margin:0;padding:0}" +
            ".athletes_photo header h1 {font-size:24px;margin:0 0 14px} .athletes_photo {margin:10px 0 0 0!important}" +
            ".athletes_photo header {text-align: center;padding: 44px 0;margin:0;color: #444;font-weight: 600;} .big_title {font-size: 14px;}.small_title {font-size: 12px;}" +
            "table {border:1px solid #999!important} table thead .ths p {margin:0;padding:0} table thead .ths {height: 40px;box-sizing: border-box;vertical-align: middle;font-size:14px!important;border-right:2px solid #999}" +
            "table tbody td .cell {color:#000} table tbody td {padding: 8px 2px;font-size: 13px;vertical-align: middle;border-top: 1px solid #999;border-right:1px solid #999}" +
            ".head_title {font:500 18px pfSem;line-height: 1;color: #444;padding:0;margin: 0 30px 15px 0;min-width: 300px;display:flex;align-items:center;}" +
            ".head_title>span,.head_title>p {display:flex;align-items:center;width: 90px;justify-content:space-between;line-height:1;margin:0;padding:0;flex-shrink:0}" +
            ".athlete_infos {padding:10px 5px!important} .box {display: flex;flex-wrap: wrap}" +
            ".page_break {margin-top:15mm!important} .info {margin-bottom:20px} table {margin-top:20px}  main {margin:15mm 0} h1 { margin:5mm 0 40px 0;font-size:24px;text-align:center }" +
            '</style></head><body style="zoom: 80%;">' +
            el.innerHTML +
            "</body></html>"
        );
        doc.close();
        iframe.contentWindow.focus();
        iframe.onload = function() {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        };
      });
    },
    //   同意驳回
    operation(type) {
      let id = null;
      this.matchList.filter(item => {
        if (item.id === this.headValue.matchName) id = item.matchId;
      });
      type === "agree"
        ? (this.loadingData.submitLoading = true)
        : (this.loadingData.saveLoading = true);
      schoolAudit({
        id: this.query.id,
        state: type === "agree" ? 3 : 2
      })
        .then(res => {
          this.openSuccess(type === "agree" ? "审核成功！" : "驳回成功！");
          type === "agree"
            ? (this.loadingData.submitLoading = false)
            : (this.loadingData.saveLoading = false);
          this.$router.push({
            path: "/aerobics/aerobics-registration-form-view",
            query: {
              id,
              year: this.headValue.year
            }
          });
        })
        .catch(err => {
          type === "agree"
            ? (this.loadingData.submitLoading = false)
            : (this.loadingData.saveLoading = false);
        });
    },
    // 报名表与运动员照片切换
    selectType(type) {
      this.switchType = type;
    },
    // 生成表格
    makeTable(count) {
      this.tableData = [];
      for (let i = 0; i < count; i++) {
        this.tableData.push({
          athleteId: "",
          group: "",
          gender: "",
          name: "",
          genderText: "",
          athleteId: "",
          startSchoolDateText: "",
          schoolSystemText: "",
          registerNumber: "",
          competitiveGymnastics: "",
          nationalFitness: ""
        });
      }
    },
    // 获取赛事列表
    getMatch() {
      getSignListBySchool({
        project: 3,
        year: this.headValue.year
      })
        .then(res => {
          if (res.length > 0) {
            this.matchList = res;
            this.headValue.matchName = res[0].id;
            this.isShowBtn = true;
            this.makeTable(res[0].count);
            this.getSignDetail(res[0].id);
          } else {
            this.matchList = [];
            this.headValue.matchName = "";
            this.isShowBtn = false;
            this.details = {};
          }
          this.hideMask = true;
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowBtn = false;
          }
          this.hideMask = true;
        });
    },
    // 获取教练员列表
    getCoachLists() {
      getCoachList({})
        .then(res => {
          this.coachList = [...res];
        })
        .catch(err => {});
    },
    // 获取详情，如果有数据，则且状态为0，则表示为草稿箱数据
    getSignDetail(id) {
      signDetail({ project: 3, id })
        .then(res => {
          this.columns = [
            {
              title: "序号",
              width: 60
            },
            {
              title: "姓名",
              width: 100,
              key: "athleteName"
            },
            {
              title: "性别",
              width: 60,
              key: "genderText"
            },
            {
              title: "入学时间",
              width: 100,
              key: "startSchoolDateText"
            },
            {
              title: "学制",
              width: 100,
              key: "schoolSystemText"
            },
            {
              title: "注册号",
              width: 160,
              key: "registerNumber"
            }
          ];
          this.matchList.filter(item => {
            if (item.id == id) this.currentProject = item;
          });
          this.makeTable(res.count);
          this.reviewState = res.state;
          Object.assign(this.query, {
            leaderName: res.leaderName,
            coachIds: !res.coachIds ? [] : res.coachIds.split(","),
            id: res.id
          });
          let competitiveGymnasticsLen = 0;
          let nationalFitnessLen = 0;
          // 获取竞技操项目、健身操项目报名项目的最大值
          res.athleteList.filter((item, index) => {
            var competitive = item.projectJson.competitiveGymnastics.split(",")
              .length;
            competitiveGymnasticsLen =
              competitiveGymnasticsLen < competitive
                ? competitive
                : competitiveGymnasticsLen;
            var national = item.projectJson.nationalFitness.split(",").length;
            nationalFitnessLen =
              nationalFitnessLen < national ? national : nationalFitnessLen;
          });
          if (res.athleteList.length > 0) {
            res.athleteList.filter((item, index) => {
              const competitiveGymnastics = item.projectJson.competitiveGymnastics.split(",");
              const nationalFitness = item.projectJson.nationalFitness.split(",");
              let obj = {};
              // 判断每一个运动员报名竞技操项目的数量是否小于所有报名运动员中的最大数量,如果小于,则根据小于的数量,添加空格
              if (competitiveGymnastics.length < competitiveGymnasticsLen) {
                const le =
                  competitiveGymnasticsLen - competitiveGymnastics.length;
                let arr = [];
                for (let i = 0; i < le; i++) {
                  arr.push("");
                }
                competitiveGymnastics.splice(1, 0, ...arr);
              }
              // 判断每一个运动员报名全民健身操项目的数量是否小于所有报名运动员中的最大数量,如果小于,则根据小于的数量,添加空格
              if (nationalFitness.length < nationalFitnessLen) {
                const le = nationalFitnessLen - nationalFitness.length;
                let arr = [];
                for (let i = 0; i < le; i++) {
                  arr.push("");
                }
                nationalFitness.splice(1, 0, ...arr);
              }
              competitiveGymnastics.filter((item, i) => {
                obj["competitiveGymnastics" + i] = item;
              });
              nationalFitness.filter((item, i) => {
                obj["nationalFitness" + i] = item;
              });
              Object.assign(res.athleteList[index], {
                ...obj
              });
              if (index == 0) {  
                competitiveGymnastics.filter((item, index) => {
                  this.columns.push({
                    key: "competitiveGymnastics" + index,
                    width: "130",
                    title: "参赛项目" + (index + 1)
                  });
                });
                nationalFitness.filter((item, index) => {
                  this.columns.push({
                    key: "nationalFitness" + index,
                    width: "130",
                    title: "参赛项目" + (index + 1)
                  });
                });
                this.competitiveGymnasticsNum = competitiveGymnastics.length;
                this.nationalFitnessNum = nationalFitness.length;
              }
            });
          }
          this.details = { ...res };
          this.selectType(this.switchType);
          this.isShowData = true;
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowData = false;
          }
        });
    }
  },
  mounted() {
    this.getYearLists(this.headValue, this.getMatch);
    this.getCoachLists();
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/font/pfSembold.css";
@import "../../assets/font/pf.css";
.application_form_review {
  .query_wapper {
    margin-bottom: 20px;
  }

  .table_box {
    > .box {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .head_title {
    color: #444;
    font: 500 18px pfSem;
    line-height: 1;
    margin: 0 50px 15px 0;
    min-width: 350px;
    display: flex;
    align-items: center;
    > span,
    > p {
      display: flex;
      align-items: center;
      width: 74px;
      justify-content: space-between;
    }
  }
  .select {
    background: #1e63b0;
    color: #fff;
  }
  .normal {
    background: transparent;
    color: #999;
  }

  .big_title {
    font-size: 15px;
  }
  .small_title {
    font-size: 12px;
  }
  footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    .btns {
      margin: 0;
      color: #1e63b0;
      border: 1px solid #1e63b0;
    }
  }
  table {
    thead {
      .ths {
        background: #eee;
        height: 40px;
        box-sizing: border-box;
        vertical-align: middle;
        &:not(:last-of-type) {
          border-right: 1px solid #ddd;
        }
      }
    }
    tbody {
      td {
        padding: 8px 2px;
        font-size: 14px;
        vertical-align: middle;
        border-top: 1px solid #ddd;
        &:not(:last-of-type) {
          border-right: 1px solid #ddd;
        }
      }
    }
  }
}
#prints {
  position: absolute;
  left: -100000px;
  top: -100000px;
  opacity: 0;
}
</style>